<template>
    <div class="share-icon">
        <div
            class="share-icon-item"
            v-for="(shareItem, shareIndex) in shareItemList"
            :key="shareIndex"
            @click="handleClick(shareItem.type, shareItem.txt)"
        >
            <img :src="shareItem.img" />
            <p>{{ shareItem.txt }}</p>
        </div>
    </div>
</template>

<script>
import { shareItemList } from '../constant.js';
import { baseShare } from 'root/common/nativeApi';
import storage from 'root/common/util/storage.js';
// import keyConfig from 'root/common/const/localStorageKey.js';
import { gioEvariableTrackOfPrivilege } from 'root/common/gio/tqGio';
import { getUtmParams } from '@/common/gio/utm';
import env from '@/common/util/env.js';
import { isGreaterVersion } from '@/common/util/index.js';

const SHARE_METHODS_MAP = {
    wxFriend: 'wxsession',
    wxComment: 'wxtimeline',
    copy: 'copy',
};

const BIG_TJ_LOG_MAP = {
    gas: 'oil_station_list',
    ticket: 'ticket_list',
    recharge: 'recharge_detail',
    kfc: 'kfc_address_list',
    supermarket: 'supermarket_list',
    main: 'guoqing_promo_page',
};

const gioThirdVal = {
    oil_station_list: '',
    ticket_list: '',
    recharge_detail: '',
    kfc_address_list: '',
    supermarket_list: '',
    guoqing_promo_page: '',
};

export default {
    props: {
        shareInfo: Object,
        business: String,
        custormBitTjData: Object,
        custormBitTjProp: String,
        biTjData: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            // 鸿蒙暂不支持朋友圈分享，屏蔽
            shareItemList:
                !env.isHarmoneyQskApp ||
                (env.isHarmoneyQskApp &&
                    isGreaterVersion({
                        iosMinVersion: '1.0.0',
                        androidMinVersion: '1.0.0',
                        harmoneyMiniVersion: '2.37.5',
                    }))
                    ? shareItemList
                    : shareItemList.filter(item => item.type !== 'wxComment'),
        };
    },
    methods: {
        handleClick(type, txt) {
            window.bigTj &&
                window.bigTj.track('click', {
                    obj_id: 'share_method',
                    obj_type: this.custormBitTjProp || BIG_TJ_LOG_MAP[this.business],
                    item_name: type,
                    location:
                        this.business == 'ticket' && !this.custormBitTjProp
                            ? this.custormBitTjData && this.custormBitTjData.location
                            : '',
                    item_id: '',
                    item_sort: 1,
                    location_id: '',
                    location_sort: 1,
                    sa_card_id: '',
                    page_source_type: '',
                    ...this.biTjData,
                });

            gioEvariableTrackOfPrivilege('shareSuccess', {
                data: {
                    thirdBusinessType_var: gioThirdVal[BIG_TJ_LOG_MAP[this.business]],
                    shareChannel_var: txt,
                    productType_var: '',
                    productName_var: '',
                    productId_var: '',
                    ...getUtmParams(window.location.hash),
                },
            });

            if (type == 'picture') {
                storage.set('sharePosterData', {
                    imgList: this.shareInfo.posterImgList,
                    shortUrl: this.shareInfo.shortUrl,
                });
                this.$emit('close');

                window.location.href = `${window.location.origin}/new/topic/views/sharePicture/sharePicture.html?ZZCAppArg=AppOpenPage`;
                return;
            }
            if (type == 'copy') {
                this.$emit('handleCopy', this.shareInfo.copyText);
                return;
            }
            this.shareBaseApi(type);
            this.$emit('close');
        },
        shareBaseApi(type) {
            window.zzc &&
                baseShare({
                    title: this.shareInfo.wxTitle || '全球购骑士特权',
                    content: this.shareInfo.wxDesc,
                    photo:
                        this.shareInfo.wxIcon ||
                        'https://imgcdn4zzc.chuxingyouhui.com/static/89/29/269911a7501e4dbca4ccec104c8927f6.jpg',
                    photoUrl: '',
                    shareUrl: this.shareInfo.longUrl,
                    sharePlatform: [SHARE_METHODS_MAP[type]],
                    success(response) {
                        console.log(response);
                    },
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.share-icon {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0.5rem 0;

    .share-icon-item {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        img {
            width: 0.9rem;
            height: 0.9rem;
        }

        p {
            color: #333333;
            font-size: 0.28rem;
            margin-top: 0.24rem;
        }
    }
}
</style>
